/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.23.0
 * @since 1.23.0
 */

import styled from 'styled-components';

export const CollectiveProductSendForm = styled.form`
    width: 0;
    height: 0;
    pointer-events: none;
    visibility: hidden;
    opacity: 0;
`;
